import React from 'react';

import "./styles.css";
import BCMSModalContainer, { useBCMSModal } from "./src/BCMSModalContainer/main.jsx";

// BCMSModalComponent :: STRING -> React.Component
// Component definition for the main modal component, accepts a className
export default function BCMSModal({ className, children }){
    return (
      <div className={ `bcms-modal ${ className ?? "" }` }>
        <div className="bcms-modal-view">
          { children }
        </div>
      </div>
    );
}

// BCMSModalHeader :: STRING -> React.Component
// Modal header definition, accepts a className
export function BCMSModalHeader({ className, children }){
    return (
        <div className={ `bcms-modal-header ${ className ?? "" }` }>
          { children }
        </div>
    );
}

// BCMSModalContent :: STRING -> React.Component
// Modal content definition, accepts a className
export function BCMSModalContent({ className, children }){
    return (
        <div className={ `bcms-modal-content ${ className ?? "" }` }>
            { children }
        </div>
    );
}

// BCMSModalFooter :: STRING -> React.Component
// Modal footer definition, accepts a className
export function BCMSModalFooter({ className, children }){
    return (
        <div className={ `bcms-modal-footer ${ className ?? "" }` }>
            { children }
        </div>
    );
}

// BCMSModalButton :: STRING, FUNCTION -> React.Component
// Modal button definition, accepts a className and an onClick function
export function BCMSModalButton({ className, onClick, children }){
    return (
        <button className={ `bcms-modal-button ${ className ?? "" }` } onClick={ onClick }>
            { children }
        </button>
    );
}

// BCMSModalOpen :: STRING, * -> React.Component
// Wrapper to bind an open modal click
export function BCMSModalOpen(props) {
    const { open } = useBCMSModal();

    const className = props.className ?? "";
    const data = props.data ?? {};

    return (
        <div className={ className } onClick={ () => open(props.id, data) }>
            { props.children }
        </div>
    )
}

// BCMSModalClose :: STRING -> React.Component
// Wrapper to bind an close modal click
export function BCMSModalClose(props) {
    const { close } = useBCMSModal();
    const className = props.className ?? "";

    return (
        <div className={ className } onClick={ () => close(props.id) }>
            { props.children }
        </div>
    )
}

export { 
  BCMSModalContainer,
  useBCMSModal
};